<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-12">
        <profile :userInfo="userInfo" :userOAuth="userOAuth"></profile>
        <!-- <div class="row">
          <div v-for="stat of statData" :key="stat.icon" class="col-md-6">
            <stat :icon="stat.icon" :title="stat.title" :value="stat.value" />
          </div>
        </div> -->
      </div>
      <!-- <div class="col-xl-8">
        <radialChart :radialChart="radialChart" />
      </div> -->
    </div>
  </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { getUserInfo } from "@/helpers/utils/jwt";
import profile from "@/components/dashboard/profile";
// import stat from "@/components/dashboard/stat";
// import radialChart from "@/components/dashboard/radial-chart";
import { authComputed } from "@/state/helpers";
export default {
  page: {
    title: "Dashboard",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    profile,
    // stat,
    // radialChart,
  },
  data() {
    return {
      title: "Dashboard",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Default",
          active: true,
        },
      ],
      statData: [
        {
          icon: "bx bx-detail",
          title: "Orders",
          value: "1,235",
        },
        {
          icon: "bx bx-user",
          title: "Customer",
          value: "249",
        },
      ],
      radialChart: {
        series: [44, 55],
        chartOptions: {
          plotOptions: {
            radialBar: {
              dataLabels: {
                name: {
                  fontSize: "22px",
                },
                value: {
                  fontSize: "16px",
                },
                total: {
                  show: true,
                  label: "Total",
                  // eslint-disable-next-line no-unused-vars
                  formatter: function (w) {
                    // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                    return 249;
                  },
                },
              },
            },
          },
          labels: ["Verify", "Not Verify", "Laptop", "Mobile"],
          colors: ["#556ee6", "#34c38f", "#f46a6a", "#f1b44c"],
        },
      },
    };
  },
  computed: {
    ...authComputed,
    userInfo() {
      if (this.getAccessToken !== null) {
        return getUserInfo(this.getAccessToken);
      } else return {};
    },
    userOAuth() {
      let user = this.$cookies.get(".oauth.usr");
      return user;
    },
  },
  beforeMount() {},
  mounted() {
    // let oauth = document.createElement('script')
    // oauth.setAttribute('src', '@/assets/oauth.js')
    // oauth.async = true
    // document.head.appendChild(oauth)

    // let jquery = document.createElement('script')
    // jquery.setAttribute('src', '@/assets/jquery-3.5.1.min.map')
    // jquery.async = true
    // document.head.appendChild(jquery)
    // eslint-disable-next-line no-undef
    // eslint-disable-next-line no-undef
  },
};
</script>
